<app-filters-checkbox-item
    [attr.title]="filterItem.value"
    [option]="filterItem"
    (selectionChange)="onSelectionChanged()"
></app-filters-checkbox-item>
